@if (isLoading()) {
<mat-progress-bar mode="indeterminate" style="position: fixed; top: 0; left: 0; z-index: 9999;"></mat-progress-bar>
}
<router-outlet />